import React, { useState } from 'react';
import { CtaButton, ModalContainer } from '@tassomutuo-backoffice/ui';
import { Box, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { alpha } from '@mui/material/styles';
import { MenuItem } from '@tassomutuo-backoffice/types';

interface IProps {
  open: boolean;
  handleClose: () => void;
  text: string;
  onConfirm: () => Promise<MenuItem>;
}

const MenuVoiceConfirmDeleteModal = ({
  open,
  handleClose,
  text,
  onConfirm,
}: IProps) => {
  const [loading, setLoading] = useState(false);

  const confirmHandler = async () => {
    try {
      setLoading(true);
      await onConfirm();
      handleClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalContainer
      open={open}
      handleClose={!loading ? handleClose : () => {}}
      mtHeader={0}
    >
      <Box display="flex" flexDirection="column" alignItems="center" gap={4}>
        <Box
          sx={{
            bgcolor: (th) => alpha(th.palette.primary.dark, 0.2),
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <DeleteIcon color="primary" />
        </Box>
        <Typography fontSize="20px" textAlign="center">
          {text}
        </Typography>
        <CtaButton
          variant="contained"
          onClick={confirmHandler}
          loading={loading}
        >
          Conferma
        </CtaButton>
      </Box>
    </ModalContainer>
  );
};

export default MenuVoiceConfirmDeleteModal;
